import type { StorytellingCardVariantType } from '../components/StorytellingCardUp/HeroCardTile4Up/types';

export const STORYTELLING_CARD_VARIANTS: Record<
    StorytellingCardVariantType,
    string
> = {
    Hero: 'hero',
    'Hero Tile': 'hero-tile',
    'Brand Spotlight': 'brand-spotlight',
    'Promo Card': 'promo-card',
    'Nav Card': 'nav-card',
    Original: 'original',
};
